module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'AgreementList'
      }
    }
  }, [_vm._v("Umowy")]), _vm._v("/"), (_vm.item && !_vm.loading) ? _c('span', [_vm._v(_vm._s(_vm.item.customerData.name) + "/" + _vm._s(_vm.item['fullNumber']))]) : _vm._e()], 1), _vm._v(" "), (_vm.item && !_vm.loading) ? _c('div', {
    staticClass: "page-title__buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'AgreementUpdate',
        params: {
          id: _vm.item['id']
        }
      },
      "title": "Edytuj"
    }
  }, [_c('span', [_vm._v("Edytuj")]), _c('svg-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1), _vm._v(" "), (_vm.item.invoice == null) ? _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#",
      "title": "usuń"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteItem($event)
      }
    }
  }, [_c('span', [_vm._v("Usuń")]), _c('svg-icon', {
    attrs: {
      "name": "minus"
    }
  })], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.deleteError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Nie udało się usunąć umoawy. Aby usunięcie umowy było możliwe umowa nie może zawierać faktur\\Potrąceń\\Zaliczek\\Zwrotów ani faktury wystawionej do tej umowy")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.item && !_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Numer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item['fullNumber']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Data zawarcia")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(_vm.item['date'])))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "element_status",
    class: _vm.item.status
  }, [_vm._v(_vm._s(_vm._f("translate")(_vm.item['status'])))])])]), _vm._v(" "), (_vm.item.leftToPaid > 0) ? _c('tr', [_c('td', [_vm._v("Suma faktur niezapłaconych")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.leftToPaid))])]) : _vm._e(), _vm._v(" "), (_vm.item.paidOn) ? _c('tr', [_c('td', [_vm._v("Data spłaty")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(_vm.item.paidOn)) + " ")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Waluta")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.currency.name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Prowizja")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")(_vm.item['commission'])))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Klient")]), _vm._v(" "), _c('td', [(_vm.item) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'CustomerShow',
        params: {
          id: _vm.item['customer']
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.item.customerData.name))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.item.invoice) ? _c('tr', [_c('td', [_vm._v("Faktura")]), _vm._v(" "), _c('td', [(_vm.item) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'InvoiceShow',
        params: {
          id: _vm.item.invoice.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.item.invoice.fullNumber))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.item.comments) ? _c('tr', [_c('td', [_vm._v("Uwagi")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item['comments']))])]) : _vm._e()])])])]) : _vm._e()], 1), _vm._v(" "), (_vm.item && !_vm.loading) ? _c('div', {
    staticClass: "col page-element"
  }, [_c('page-title', [_c('h3', [_vm._v("Lista faktur")])]), _vm._v(" "), _c('invoice-list', {
    attrs: {
      "id": _vm.item['id']
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27d643a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement/Show.vue
// module id = 798
// module chunks = 0